<div class="container-form" *ngIf="!showConfirmationStep; else confirmationStep">
  <!--BIENVENIDA -->
  <form action="" autocomplete="off" [formGroup]="form" class="form" (ngSubmit)="onSubmit()">
    <div style="padding-top: 20px;">
    <div class="col-md-6 div-input">
      <!-- NOMBRES -->
      <label for="" class="text-label">Nombre(s)</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su nombre completo"
          formControlName="firstName"
          oninput="this.value = this.value.toUpperCase()"
          (keydown)="isLetter($event)"
          onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
        />
        <mat-error *ngIf="form.controls['firstName'].invalid && form.controls['firstName'].touched">
          <span *ngIf="form.controls['firstName'].errors && form.controls['firstName'].errors['required']">Debe completar este campo</span>
          <span *ngIf="form.controls['firstName'].errors && form.controls['firstName'].errors['pattern']">Verifique los espacios en blanco</span>
          <span *ngIf="form.controls['firstName'].errors && form.controls['firstName'].errors['required']">Debe completar este campo</span>
          <span *ngIf="form.controls['firstName'].errors && form.controls['firstName'].errors['pattern']">Verifique los espacios en blanco</span>
        </mat-error>
        <mat-error *ngIf="form.controls['firstName'].hasError('maxlength')">Máximo 45 caracteres.</mat-error>
        <mat-error *ngIf="form.controls['firstName'].hasError('minlength')">Mínimo 2 caracteres.</mat-error>
      </mat-form-field>
      <!-- APELLIDO PATERNO -->
      <label for="" class="text-label">Apellido Paterno</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su apellido paterno"
          formControlName="lastName"
          oninput="this.value = this.value.toUpperCase()"
          (keydown)="isLetter($event)"
          onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
        />
        <mat-error *ngIf="form.controls['lastName'].invalid && form.controls['lastName'].touched">
          <span *ngIf="form.controls['lastName'].errors && form.controls['lastName'].errors['required']">Debe completar este campo</span>
          <span *ngIf="form.controls['lastName'].errors && form.controls['lastName'].errors['pattern']">Verifique los espacios en blanco</span>
        </mat-error>
        <mat-error *ngIf="form.controls['lastName'].hasError('maxlength')">Máximo 45 caracteres.</mat-error>
        <mat-error *ngIf="form.controls['lastName'].hasError('minlength')">Mínimo 2 caracteres.</mat-error>
      </mat-form-field>

      <!-- APELLIDO MATERNO -->
      <label for="" class="text-label">Apellido Materno</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su apellido materno"
          formControlName="secondLastName"
          oninput="this.value = this.value.toUpperCase()"
          (keydown)="isLetter($event)"
          onkeypress="return /[ña-zÇÖÜÄËÏA-Z\s]/i.test(event.key)"
        />
        <mat-error *ngIf="form.controls['secondLastName'].invalid && form.controls['secondLastName'].touched">
          <span *ngIf="form.controls['secondLastName'].errors && form.controls['secondLastName'].errors['required']">Debe completar este campo</span>
          <span *ngIf="form.controls['secondLastName'].errors && form.controls['secondLastName'].errors['pattern']">Verifique los espacios en blanco</span>
        </mat-error>
        <mat-error *ngIf="form.controls['secondLastName'].hasError('maxlength')">Máximo 45 caracteres.</mat-error>
        <mat-error *ngIf="form.controls['secondLastName'].hasError('minlength')">Mínimo 2 caracteres.</mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-6 div-input">
      <!-- CORREO ELECTRONICO -->
      <label for="" class="text-label">Correo electrónico</label>
      <mat-form-field appearance="outline">
        <input
          matInput
          placeholder="Ingrese su correo electrónico"
          [formControl]="emailCtrl"
          type="email"
          (keydown)="deleteSpaceInit($event)"
          matTooltip="Verifica que este escrito correctamente tu correo ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
        />
        <mat-error *ngIf="emailCtrl.invalid && emailCtrl.touched">
          <span *ngIf="emailCtrl.errors && emailCtrl.errors['required']">Debe completar este campo</span>
        </mat-error>
        <mat-error *ngIf="emailCtrl.hasError('pattern')" class="error-email">Formato incorrecto.</mat-error>
        <mat-error *ngIf="emailCtrl.hasError('emailEnd')" class="textProviders">Formato de email incorrecto.</mat-error>
        <mat-icon matSuffix>notification_important</mat-icon>
      </mat-form-field>

      <!-- CODIGO PAIS -->
      <label for="" class="text-label">Número de teléfono</label>
      <div>
        <mat-form-field appearance="outline" style="width: 40%">
          <mat-select formControlName="cellPhoneCountryCode">
            <mat-option *ngFor="let opcion of phoneCountryCode" [value]="opcion.countryCode">
              <img src="{{ opcion.imageUrl }}" class="image" />
              {{ opcion.phoneCode }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls['cellPhoneCountryCode'].invalid && form.controls['cellPhoneCountryCode'].touched">
            <span *ngIf="form.controls['cellPhoneCountryCode'].errors && form.controls['cellPhoneCountryCode'].errors['required']">Debe completar este campo</span>
          </mat-error>
        </mat-form-field>

        <!-- TELEFONO CELULAR -->
        <mat-form-field appearance="outline" style="width: 60%">
          <input
            appNumber
            matInput
            placeholder="Ingrese su número de celular"
            formControlName="mobilePhoneNumber"
            matTooltip="Verifica que este escrito correctamente tu Teléfono ya que deberás validarlo y será el oficial donde recibirás comunicaciones de parte de Vemo."
          />
          <mat-error *ngIf="form.controls['mobilePhoneNumber'].invalid && form.controls['mobilePhoneNumber'].touched">
            <span *ngIf="form.controls['mobilePhoneNumber'].errors && form.controls['mobilePhoneNumber'].errors['required']">Debe completar este campo</span>
          </mat-error>
          <mat-error
            class="error-phone"
            *ngIf="
              form.controls['mobilePhoneNumber'].hasError(
                'pattern'
              )
            "
            >Debe ingresar 10 caracteres.
          </mat-error>
          <mat-icon matSuffix>notification_important</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <!-- AVISO DE PRIVACIDAD -->
    <div class="privacy-agreement">
      <div class="privacy-agreement__checkbox-wrapper div-check">
        <mat-checkbox formControlName="privacyNoticeAccepted"></mat-checkbox>
        Acepto el Aviso de Privacidad.
        <button
          mat-icon-button
          type="button"
          aria-label="Example icon button with a vertical three dot icon"
          class="color-button"
          (click)="openNoticeOfPrivacyDialog()"
        >
          <mat-icon>help</mat-icon>
        </button>
      </div>
    </div>
    <mat-error class="error" *ngIf="form.controls['privacyNoticeAccepted'].invalid && form.controls['privacyNoticeAccepted'].touched">
      <span *ngIf="form.controls['privacyNoticeAccepted'].errors && form.controls['privacyNoticeAccepted'].errors['required']">Es necesario aceptar terminos</span>
    </mat-error>
    </div>
  </form>

  <div class="div-button-form">
    <div class="boton-siguiente-lto-container">
      <div class="boton-siguiente-lto-container__buttons">
        <button
          class="boton-siguiente-lto"
          type="submit"
          mat-raised-button
          [disabled]="!isFormValid || emailCtrl.invalid || isWaitingApi"
          (click)="onSubmit()"
        >
          ENVIAR MI SOLICITUD
        </button>

      <mat-spinner class="save-spinner" diameter="26" *ngIf="isWaitingApi"></mat-spinner>
    </div>
  </div>
</div>
</div>

<ng-template #confirmationStep>
  <section class="details details--confirmation">
    <h2 class="text-title">
      ¡Gracias por enviar la solicitud!
      <div class="container-subtitle container-subtitle--confirmation">
        <h2 class="text-subtitle">Pronto nos pondremos en contacto contigo.</h2>
      </div>
    </h2>
    <img src="assets/images/car-thank-you.png" alt="Vemo Impulso" />
  </section>
</ng-template>
